<template>
  <div class="OrderMaterialList">
    <el-dialog width="1000px" height="500px" :before-close="handleClose" class="dialog-wrap form-module" :visible.sync="isDialogShow" @open="handleOpen">
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem">
        <div>
          <el-table max-height="400" :data="materialList" class="table_wrap1" border show-summary style="width: 100%">
            <el-table-column prop="MaterialCode" label="物品代码"></el-table-column>
            <el-table-column prop="MaterialName" label="物品名称"></el-table-column>
            <el-table-column prop="Specification" label="品牌规格"></el-table-column>
            <el-table-column prop="ActualCount" label="采购数量"></el-table-column>
            <el-table-column prop="InvoiceCount" label="验收数"></el-table-column>
            <el-table-column prop="CancelCount" label="取消数"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    orderId: {
      type: String,
      default: ''
    },
    isDialogShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      materialList: []
    }
  },
  mounted() {
    if (!this.isEmpty(this.orderId)) {
      this.getData()
    }
  },
  methods: {
    getData() {
      let config = {
        params: {
          OrderId: this.orderId
        }
      }
      this.getRequest('/Order/GetOrderData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.materialList = res.data.materialList
          this.materialList = this.materialList.filter((item) => {
            return Number(item.ConfirmResults) < 3
          })
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    handleClose() {
      this.$emit('update:isDialogShow', false)
    },
    handleOpen() {
      if (!this.isEmpty(this.orderId)) {
        this.getData()
      }
    },
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.OrderMaterialList {
  ::v-deep .table_wrap1 {
    table {
      margin: 0;

      td,
      tr,
      th {
        border-color: #95c7f0;
      }

      th {
        border-top: 1px solid #95c7f0;
        border-right: 1px solid #95c7f0;
        border-color: #95c7f0;
        background-color: #d8eafa;

        &:first-child {
          border-left: 1px solid #95c7f0;
        }
      }

      td {
        border-bottom: none;

        &:first-child {
          border-left: 1px solid #95c7f0;
        }
      }
    }

    .el-table__body-wrapper {
      border-bottom: 1px solid #95c7f0;
    }
  }
}
</style>